import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { useState } from 'react'

export default function DiscountEntry({ checkout, disabled }) {
  const [discountCode, setDiscountCode] = useState('')
  const [applyState, setApplyState] = useState('reset')

  function getDiscountApplyBtnText() {
    switch (applyState) {
      case 'applying':
        return 'Applying'
      case 'applied':
        return <FontAwesomeIcon icon={faCheck} />
      default:
        return 'Apply'
    }
  }

  function onDiscountCodeChange(v) {
    // remove the old discount
    checkout.removeDiscountCode()
    setApplyState('reset')
    setDiscountCode(v)
  }

  async function applyDiscountCode() {
    setApplyState('applying')

    try {
      await checkout.setDiscountCode(discountCode)
      setApplyState('applied')
    } catch (err) {
      setApplyState('reset')
    }
  }

  return (
    <div className="row mb-3">
      <div className="col-8">
        <input
          type="text"
          className="form-control"
          placeholder="Discount code"
          disabled={disabled}
          value={discountCode}
          onChange={(v) => onDiscountCodeChange(v.target.value)}
        />
        <small className="text-muted">Only applies to items total.</small>
      </div>

      <div className="col">
        <div>
          <button
            type="button"
            className="btn btn-secondary text-white w-100"
            onClick={applyDiscountCode}
            disabled={applyState !== 'reset'}
          >
            {getDiscountApplyBtnText()}
          </button>
        </div>
      </div>
    </div>
  )
}
